import { render } from "./PolicyCreate.vue?vue&type=template&id=7c6b5c36&scoped=true"
import script from "./PolicyCreate.vue?vue&type=script&lang=js"
export * from "./PolicyCreate.vue?vue&type=script&lang=js"

import "./PolicyCreate.vue?vue&type=style&index=0&id=7c6b5c36&scoped=true&lang=css"

import exportComponent from "C:\\projects\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Company\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c6b5c36"]])

export default __exports__